import React from 'react'
import { Form, Typography } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { useUseCase } from '@s4l/utils/hooks/useUseCase'
import { ListOfTheme } from '@s4l/stayforlong/property/domain/ListOfTheme'
import debug from 'debug'
import { useSearchMetadata } from '../useSearchMetadata'

const log = debug('s4l:uikit:FilterThemes')

const FilterThemes = () => {
  const { i18n } = useS4LContext()

  const { data, fulfilled, loading, error } = useUseCase('GetListOfThemesPropertyUseCase')
  const { searchMetadata } = useSearchMetadata()

  if (error) {
    log('Error in GetListOfThemesPropertyUseCase')
  }

  const hasInfo = fulfilled && !loading && !data?.isEmpty()

  if (error) return null

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'filter-category.trip-type' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>

      {loading && (
        <Form.Skeleton isLoading>
          {Array.from({ length: ListOfTheme.MAX_FEATURED }, (_, index) => index).map(item => {
            return (
              <Form.Label key={item}>
                Loading trip type
                <Form.Checkbox name="themes" multiple />
              </Form.Label>
            )
          })}
        </Form.Skeleton>
      )}

      {hasInfo && (
        <>
          {data?.getFeatured().map(theme => {
            const count = searchMetadata?.themes?.getByKey(theme.slug)?.count ?? 0
            return (
              <Form.Label key={`theme-${theme.slug}`}>
                {theme.name}
                {searchMetadata && (
                  <Typography variant="caption" size="l" color="neutral-800">
                    {count}
                  </Typography>
                )}
                <Form.Checkbox
                  disabled={searchMetadata && !count}
                  name="themes"
                  multiple
                  trueValue={theme.slug}
                />
              </Form.Label>
            )
          })}

          <Form.Collapsible
            textMore={i18n.formatMessage({ id: 'global.show-all' })}
            textLess={i18n.formatMessage({ id: 'global.show-less' })}
          >
            {data?.getNonFeatured().map(theme => {
              const count = searchMetadata?.themes?.getByKey(theme.slug)?.count ?? 0
              return (
                <Form.Label key={`theme-${theme.slug}`}>
                  {theme.name}
                  {searchMetadata && (
                    <Typography variant="caption" as="span" size="m" color="neutral-800">
                      {count}
                    </Typography>
                  )}
                  <Form.Checkbox
                    disabled={searchMetadata && !count}
                    name="themes"
                    multiple
                    trueValue={theme.slug}
                  />
                </Form.Label>
              )
            })}
          </Form.Collapsible>
        </>
      )}
    </Form.Fieldset>
  )
}

FilterThemes.displayName = 'SearchFilters.FilterThemes'
export default withErrorBoundary(FilterThemes)
